export const isPlugin = (inNode: HTMLElement, inName: string) => {
  const tagName: string | undefined = inNode.tagName;
  return tagName ? tagName.toLowerCase() === inName : false;
};
